import { GridColumnVisibilityModel } from '@mui/x-data-grid-pro'
import React from 'react'
import DepartmentsDataGrid from 'src/components/DataGrid/tables/DepartmentsDataGrid/DepartmentsDataGrid'
import { DepartmentResponse } from 'src/queries/organizations/department.queries'

interface DepartmentsTableProps {
  departments: DepartmentResponse[]
  organizationId: string
}

const DepartmentsTable: React.FC<DepartmentsTableProps> = (props) => {
  const defaultColumnVisibilityModel: GridColumnVisibilityModel = {
    departmentName: true,
    description: true,
    departmentCode: true,
    departmentSize: true,
  }

  return (
    <DepartmentsDataGrid
      organizationId={props.organizationId}
      departments={props.departments}
      defaultColumnVisibilityModel={defaultColumnVisibilityModel}
    />
  )
}

export default DepartmentsTable
